module.exports = __webpack_public_path__ + "static/img/banner6.87e806f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner6.png
// module id = PxYo
// module chunks = 1